// src/pages/Inspiration.js 
// (Assuming this file contains your Inspiration component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; 
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import InspirationContent from "./PageComponent/InspirationContent";


function Inspiration() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>New inspiration | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Discover fresh ideas to boost your creativity. Explore our new inspiration section and ignite your imagination today!"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/inspiration/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="New inspiration" />
                <meta
                    property="og:description"
                    content="Discover fresh ideas to boost your creativity. Explore our new inspiration section and ignite your imagination today!"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/inspiration/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <InspirationContent />
                <Footer />
            </div>
        </>
    );
}

export default Inspiration;